export const locale = {
    back: 'Назад',
    close: 'Закрыть',
    last: 'Последний',
    next: 'Следующий',
    open: 'Открыть диалог',
    skip: 'Пропустить'
};
